import LatestNews from './latest-news';
import HoverCursorManager from "../../helpers/hover-cursor-manager";
import ScrollMagic from "scrollmagic";
import {PageEvent} from '~/pages/page.js';

export default class LatestNewsDesktop extends LatestNews {
    constructor(...args) {
        super(...args);

        this.animated = true;

        this._isEdge = ( ENV.browser == 'edge' );
        this._isHome = this.dom.component.classList.contains('is-home');

        if( ENV.device == 'desktop' ) {
            this._HoverCursorManager = new HoverCursorManager( {
                container : this.dom.component,
                gallery : {
                    classesName : {
                        items : 'js-slide',
                        icons : 'js-icon-download'
                    }
                }
            } );
        }

    }

    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.animate = {
            text : this.dom.component.querySelector('.js-block-text'),
            cards : this.dom.component.querySelector('.news-container'),
        };

    }

    init() {
        super.init();

        if( !this._isEdge || !this._isHome )
            this._initScrollAnim();
    }

    _initScrollAnim() {
        this._animContent();
    }

    _animContent() {
        // Create Tweenmax Animation
        let tweenContent = new TimelineMax();
        tweenContent
            .fromTo( this.dom.animate.text, 5, { y: 300 }, { y: 0, ease: Power4.easeOut }, 'init' )
            .fromTo( this.dom.animate.cards, 5, { y: 300 }, { y: 0 , ease: Power4.easeOut }, 'init+=1')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            offset: -window.innerHeight / 3,
            duration: this.dom.component.offsetHeight
        });
        scene.setTween( tweenContent );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    _update( pos ) {

        if( ENV.device == 'desktop' ) {
            this._HoverCursorManager.update( pos );
        }
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/latest-news/latest-news.desktop.js